import React from 'react'
import { Autocomplete, TextField } from '@mui/material'

import {
  AUTOCOMPLETE_POPPER_SLOT_PROPS,
  STORE_RELATION_FORM_TEXT
} from '../constants/storeRelationFormConstants'

const BaseInfoAutocomplete = ({
  label,
  options = [],
  value = null,
  inputValue = '',
  loading = false,
  disabled = false,
  required = false,
  error = false,
  helperText = '',
  sx = undefined,
  onChange,
  onInputChange,
  onLoadMore
}) => (
  <Autocomplete
    className="store-relations-form__autocomplete"
    fullWidth
    disabled={disabled}
    sx={sx}
    slotProps={{
      popper: AUTOCOMPLETE_POPPER_SLOT_PROPS,
      listbox: {
        onScroll: (event) => {
          const listboxNode = event.currentTarget
          const reachedBottom =
            listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 24

          if (reachedBottom) {
            onLoadMore?.()
          }
        }
      }
    }}
    filterOptions={(availableOptions) => availableOptions}
    options={options}
    loading={loading}
    value={value}
    inputValue={inputValue}
    isOptionEqualToValue={(option, currentValue) => option?.id === currentValue?.id}
    getOptionLabel={(option) => option?.label || ''}
    onChange={onChange}
    onInputChange={onInputChange}
    noOptionsText={STORE_RELATION_FORM_TEXT.NO_OPTIONS}
    loadingText={STORE_RELATION_FORM_TEXT.LOADING_OPTIONS}
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        required={required}
        error={error}
        helperText={helperText}
        label={label}
      />
    )}
  />
)

export default BaseInfoAutocomplete
